module.exports = __webpack_public_path__ + "9d404af3a3708e13b05ff6eafe93929c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/bckrd.jpg
// module id = 456
// module chunks = 0